import { ExclusionItemGridController } from '../controller/ExclusionItemGridController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class ExclusionItemGridWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ExclusionItemGridController,
    });
  }
}
